import { useCallback } from "react";
import SectionCard from "components/cms/SectionCard";
import BodyBlocks from "components/cms/BodyBlocks";
import CategoryPicker from "components/cms/CategoryPicker";
import {
  AreaInput,
  CardRow,
  FieldRow,
  FileInput,
  TextInput,
} from "components/cms/fields";
import { emptyBlock, listArticles } from "api/article";
import { uniqueOptions } from "utils/cms";

export default function ArticleStack({ form, setForm, setField, frMap }) {
  const loadCategories = useCallback(async () => {
    const res = await listArticles();
    return uniqueOptions(res.data?.data?.items, "categorySlug", "categoryLabel");
  }, []);

  return (
    <>
      <SectionCard title="Article" description="Same template as every Knowledge Hub article">
        <FieldRow>
          <TextInput label="Slug" path="slug" form={form} setField={setField} placeholder="ai-agents-for-smb" />
          <TextInput label="Published date" path="publishedAt" form={form} setField={setField} placeholder="2026-05-13" />
        </FieldRow>
        <FieldRow>
          <TextInput label="Read minutes" path="readMinutes" form={form} setField={setField} type="number" />
          <label className="flex items-center gap-2 pt-7 text-sm text-navy-700 dark:text-white">
            <input
              type="checkbox"
              checked={!!form.featured}
              onChange={(event) => setField("featured", event.target.checked)}
            />
            Featured on Knowledge Hub
          </label>
        </FieldRow>
        <AreaInput label="Title" path="title" form={form} setField={setField} frMap={frMap} rows={2} />
        <AreaInput label="Excerpt" path="excerpt" form={form} setField={setField} frMap={frMap} rows={3} />
        <CategoryPicker
          label="Category"
          slugPath="categorySlug"
          labelPath="categoryLabel"
          form={form}
          setField={setField}
          frMap={frMap}
          loadOptions={loadCategories}
          newLabel="Add new category"
        />
        <TextInput label="Tags (comma separated)" path="tags" form={form} setField={setField} frMap={frMap} />
      </SectionCard>

      <SectionCard title="Author & cover">
        <FieldRow>
          <TextInput label="Author name" path="authorName" form={form} setField={setField} />
          <TextInput label="Author role" path="authorRole" form={form} setField={setField} frMap={frMap} />
        </FieldRow>
        <CardRow>
          <FileInput label="Author avatar" path="authorAvatar" form={form} setField={setField} />
          <FileInput label="Cover image" path="cover" form={form} setField={setField} />
        </CardRow>
        <TextInput label="Cover alt text" path="coverAlt" form={form} setField={setField} frMap={frMap} />
      </SectionCard>

      <BodyBlocks
        form={form}
        setForm={setForm}
        setField={setField}
        frMap={frMap}
        emptyBlock={emptyBlock}
        description="Blocks render in the article template"
      />
    </>
  );
}
